import React from "react";

// ==== Import Images ====
import img05 from "../../../images/about/img05.jpg";
import img06 from "../../../images/about/img06.jpg";
import img07 from "../../../images/about/img07.jpg";
import img08 from "../../../images/about/img08.jpg";

import videoPoster from "../../../images/about/video-img.png";

import gif1 from "../../../images/icon/original-66948a0d81d.gif";
import gif2 from "../../../images/icon/0deec720000b2066289b.gif";
import gif3 from "../../../images/icon/b10c3e43e836d32554bf.gif";

import featureIcon1 from "../../../images/icon/feature-icon01.svg";
import featureIcon2 from "../../../images/icon/feature-icon02.svg";
import featureIcon3 from "../../../images/icon/feature-icon03.svg";

import aboutBg from "../../../images/bg/about-bg02.png";
import { Link } from "react-router-dom";

const AboutSection: React.FC = () => {
  return (
    <section className="about pos-rel pb-140">

      <div className="container">
        {/* ===== Top Scrolling Images ===== */}

        {/* ===== Mission Statement ===== */}
        <div className="sec-title sec-title-center about-sec-title about-sec-title-two mt-45">
          <span className="sub-title mb-10">Our Mission</span>

          <h2 className="title">
            Empowering communities through
            <span><img src={gif2} alt="gif" /></span>
            technology and
            innovation for all
          </h2>

          <p className="content">
            At AquarLabs, we believe technology should serve humanity. We are committed to
            changing the future for those who need support most — using innovation to bridge gaps,
            create opportunities, and make lives better through the power of technology.
          </p>
        </div>

        {/* ===== Our Values Section ===== */}
        <div style={{
          background: "rgba(255,255,255,0.02)",
          borderRadius: "24px",
          padding: "50px 40px",
          marginTop: "60px",
          border: "1px solid rgba(252, 144, 56, 0.2)"
        }}>
          <h3 style={{
            textAlign: "center",
            color: "#fc9038",
            fontSize: "1.3rem",
            marginBottom: "30px",
            fontWeight: "600",
            textTransform: "uppercase",
            letterSpacing: "2px"
          }}>Our Values</h3>
          <div className="row">
            <div className="col-lg-4 col-md-6 mb-4">
              <div style={{ textAlign: "center", padding: "20px" }}>
                <div style={{ fontSize: "2.5rem", marginBottom: "15px" }}>🌍</div>
                <h4 style={{ color: "#fff", marginBottom: "10px" }}>Empowerment</h4>
                <p style={{ color: "rgba(255,255,255,0.7)", fontSize: "0.95rem" }}>
                  We strive to change the future for the poor and those who need support
                </p>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 mb-4">
              <div style={{ textAlign: "center", padding: "20px" }}>
                <div style={{ fontSize: "2.5rem", marginBottom: "15px" }}>💡</div>
                <h4 style={{ color: "#fff", marginBottom: "10px" }}>Innovation</h4>
                <p style={{ color: "rgba(255,255,255,0.7)", fontSize: "0.95rem" }}>
                  Using technology to solve real problems and create meaningful impact
                </p>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 mb-4">
              <div style={{ textAlign: "center", padding: "20px" }}>
                <div style={{ fontSize: "2.5rem", marginBottom: "15px" }}>❤️</div>
                <h4 style={{ color: "#fff", marginBottom: "10px" }}>Compassion</h4>
                <p style={{ color: "rgba(255,255,255,0.7)", fontSize: "0.95rem" }}>
                  Making lives better with tech, one solution at a time
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* ===== Feature Boxes ===== */}

      </div>

      {/* Background */}
      <div className="about-bg">
        <img src={aboutBg} alt="background" />
      </div>
    </section>
  );
};

export default AboutSection;
